import React from "react";
import cs from "classnames";
import styles from "./styles.module.scss";
import { ICONS } from "./icons";
import { MenuItemProps } from "./types";

const toneClass: Record<string, string> = {
  overview: styles["tone-overview"],
  apps: styles["tone-apps"],
  appInsights: styles["tone-appInsights"],
  balance: styles["tone-balance"],
  orders: styles["tone-orders"],
  planner: styles["tone-planner"],
  activity: styles["tone-activity"],
};

const MenuItem: React.FC<MenuItemProps> = ({
  item,
  active,
  opened,
  onSelect,
  className,
}) => {
  const { Svg, tone } = ICONS[item.icon];

  // Middle-click (mouse wheel button) opens the item's route in a new tab,
  // mimicking native <a> link behavior even though this is a <button>.
  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (event.button === 1 && item.to) {
      // Prevent the browser's default auto-scroll (pan) cursor on middle-click.
      event.preventDefault();
    }
  };

  const handleAuxClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (event.button === 1 && item.to) {
      event.preventDefault();
      window.open(item.to, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <button
      type="button"
      className={cs(styles.item, { [styles.active]: active }, className)}
      onClick={() => {
        item.onClick?.();
        onSelect?.(item.key);
      }}
      onMouseDown={handleMouseDown}
      onAuxClick={handleAuxClick}
      aria-current={active ? "page" : undefined}
      title={!opened ? item.label : undefined}
    >
      {active && <span className={styles.indicator} aria-hidden />}
      <span className={cs(styles.iconBox, toneClass[tone])}>
        <Svg />
      </span>
      {opened && <span className={styles.label}>{item.label}</span>}
    </button>
  );
};

export default MenuItem;
